/**
 * Session Manager Wrapper
 * Wraps the app with session management and displays warning modal
 */

import React from 'react';
import {
  SessionManagerProvider,
  useSessionManager,
} from '@/contexts/SessionManagerContext';
import type { SessionConfig } from '@/types/session';
import { SessionWarningModal } from './SessionWarningModal';

interface SessionManagerWrapperProps {
  children: React.ReactNode;
  config?: Partial<SessionConfig>;
}

/**
 * Internal component that uses the session manager context
 */
const SessionManagerContent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { showWarning, warningTimeRemaining, extendSession, logout } =
    useSessionManager();

  return (
    <>
      {children}
      <SessionWarningModal
        open={showWarning}
        timeRemaining={warningTimeRemaining}
        onExtend={extendSession}
        onLogout={logout}
      />
    </>
  );
};

/**
 * Session Manager Wrapper Component
 * Provides session management to the entire application
 */
export const SessionManagerWrapper: React.FC<SessionManagerWrapperProps> = ({
  children,
  config,
}) => {
  return (
    <SessionManagerProvider config={config} autoStart={true}>
      <SessionManagerContent>{children}</SessionManagerContent>
    </SessionManagerProvider>
  );
};

export default SessionManagerWrapper;
